class MMCountdown extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
    this.endTime = null;
  }

  connectedCallback() {
    const dateStr = this.dataset.endDate;
    if (!dateStr) return;

    this.endTime = new Date(dateStr).getTime();
    if (isNaN(this.endTime)) return;

    this.timerWrap = this.querySelector('.mm-countdown__timer-wrap');
    this.expired = this.querySelector('.mm-countdown__expired');
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minsEl = this.querySelector('[data-mins]');
    this.secsEl = this.querySelector('[data-secs]');

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const now = Date.now();
    const diff = this.endTime - now;

    if (diff <= 0) {
      clearInterval(this.interval);
      this.showExpired();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((diff % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minsEl) this.minsEl.textContent = String(mins).padStart(2, '0');
    if (this.secsEl) this.secsEl.textContent = String(secs).padStart(2, '0');
  }

  showExpired() {
    if (this.timerWrap) this.timerWrap.classList.add('is-hidden');
    if (this.expired) this.expired.classList.add('is-visible');
  }
}

// Multi-instance init with shopify:section:load support
function initMMCountdowns(scope = document) {
  scope.querySelectorAll('mm-countdown').forEach((el) => {
    if (!customElements.get('mm-countdown')) return;
    // already upgraded by CE registry
  });
}

if (!customElements.get('mm-countdown')) {
  customElements.define('mm-countdown', MMCountdown);
}

document.addEventListener('shopify:section:load', (e) => {
  initMMCountdowns(e.target);
});
